import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownPosition } from '@ng-select/ng-select';

@Component({
  selector: 's-input',
  templateUrl: './s-input.component.html',
  styleUrls: ['./s-input.component.scss']
})
export class SInputComponent implements OnInit {
  @Input() model: any;
  @Input() type: any;
  @Input() name: string;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() customClass: string = "";
  @Input() tabIndex: number = null;
  @Input() minW: boolean = true;

  @Output() blur = new EventEmitter()
  @Output() onChange = new EventEmitter() // Only here is OnChange because of propagation
  @Output() enter = new EventEmitter()
  @Output() modelChange = new EventEmitter()

  /** S-select specific **/
  @Input() items: any[] = [];
  @Input() bindValue: string;
  @Input() bindLabel: string;
  @Input() dropdownPosition: DropdownPosition = "auto";
  @Input() addTag: boolean | ((term: string) => any) = false;
  @Input() appendTo: string = null;
  @Input() loading: boolean = false;
  @Input() multiple: boolean = false;
  @Input() clearable: boolean = true;
  @Input() placeholder: string = '';
  @Input() searchFn: (term: string, item: any) => boolean
  @Input() customOption: (item: any) => string
  @Input() customLabel: (item: any) => string
  @Input() translateAppendix: string = null
  /** Switch specific **/
  @Input() color: string = "#36B4F6"
  @Input() colorOff: string = null
  @Input() size: string = "medium";
  /** Date specific **/
  @Input() alertHoliday: boolean = false;
  /** Number specific **/
  @Input() step: string = "0.01";

  typeSwitch: string

  ngOnInit(): void {
    switch (this.type) {
      case 'datetime':
        this.type = 'datetime-local'
        this.typeSwitch = 'date'
        break;
      case 'datetime-local':
      case 'time':
      case 'month':
      case 'week':
      case 'year':
        this.typeSwitch = 'date'
        break;
      case 'int':
      case 'integer':
        this.typeSwitch = 'number'
        this.step = "1"
        break;
      case 'decimal':
        this.typeSwitch = 'number'
        break;
      default:
        this.typeSwitch = this.type
        break;
    }
  }

  valueChanged() {
    this.modelChange.emit(this.model)
    this.onChange.emit(this.model)
  }

  onBlur() {
    this.blur.emit(this.model)
  }

  onEnter() {
    this.enter.emit(this.model)
  }
}
